<header class="top-navbar">
  <div class="nav-container">
    <div class="nav-logo">
      <a routerLink="/home">
        <img alt="LinkedIn" src="assets/images/my_avatar.png" title="linkedin" width="48" height="48" class="circle-img">
      </a>
    </div>
    <nav>
      <ul class="nav-links">
        <li><a routerLink="/portfolio">Portfolio</a>
        <li><a routerLink="/about">About</a></li>
        <li><a href="mailto:jawegielewski@gmail.com">Contact</a></li>
        <li class="dropdown">
          <a href="javascript:void(0)" class="dropdown-trigger">More &#9662;</a>
          <ul class="dropdown-menu">
            <li><a routerLink="/portfolio">Google Play Profile</a></li>
            <li><a href="https://github.com" target="_blank">GitHub Portfolio</a></li>
            <li><a href="#featured-app">Featured App</a></li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</header>
